import { apiClient } from './setupApi';

export const requestGetCompany = async () => {
  const { data } = await apiClient.get('/company/company-detail');
  return data;
};

export const requestCreateCompany = async (payload) => {
  const { data } = await apiClient.post('/company/', payload);
  return data;
};

export const requestUpdateCompany = async (payload) => {
  const { data } = await apiClient.put('/company/', payload);
  return data;
};

export const requestGetCompanyBranches = async () => {
  const { data } = await apiClient.get(`/company/branches`);
  return data;
};

export const requestGetDepartmentsOfBranch = async (branchId) => {
  const { data } = await apiClient.get(`/company/${branchId}/departments`);
  return data;
};

export const requestUpdateBranch = async (payload) => {
  await apiClient.patch(`/company/branche/${payload.branchId}`, payload.data);
};

export const requestDeleteBranch = async (id) => {
  await apiClient.delete(`/company/branche/${id}`);
};

export const requestDeleteDepartments = async (id) => {
  await apiClient.delete(`/company/department/${id}`);
};

export const requestCreateBranch = async (payload) => {
  const { data } = await apiClient.post(`/company/branche`, payload);

  return data;
};

export const requestCreateDepartment = async (payload) => {
  const { data } = await apiClient.post(`/company/department`, payload);

  return data;
};

export const requestUpdateDepartment = async (payload) => {
  await apiClient.patch(`/company/department/${payload.departmentId}`, payload.data);
};

export const requestUploadLogoCompany = async (id, payload) => {
  const data = await apiClient.post(`/company/${id}/logo`, payload);
  return data;
};
